import React from "react";
import {useModalContext} from "../../contexts/ModalContext/context";
import {DeleteLevelModal} from "../DeleteLevelModal/DeleteLevelModal";
import {IconButton} from "../../UI/IconButton";
import DeleteIcon from "@mui/icons-material/Delete";
import {withModalProvider} from "../../hoc/withModalProvider";
import {DeleteUnitType} from "../../services/NetworkApi";
import useAuth from "../../routes/login/AuthContext";
import { useNetworkContext } from "../../contexts/NetworkContext/context";

interface DeleteButtonProps {
    levelName: string;
    l1Id: number;
    l2Id: number;
    l3Id: number;
}

const DeleteButton: React.FC<DeleteButtonProps> = ({levelName, l1Id,l2Id, l3Id}) => {
    const {setIsOpen} = useModalContext();
    const { loadNetworkInfoForNetworks } = useNetworkContext();
    const {getAuthToken} = useAuth();

    const onConfirm = async () => {
        await DeleteUnitType(l1Id, l2Id, l3Id, await getAuthToken());
        await loadNetworkInfoForNetworks([l1Id]);
        setIsOpen(false);
    };

    return (
        <>
            <DeleteLevelModal onConfirm={onConfirm} levelType={"Unit Type"} levelName={levelName}/>
            <IconButton onClick={() => {
                setIsOpen(true);
            }}>
                <DeleteIcon/>
            </IconButton>
        </>
    );
};

export const UnitTypeDeleteButtonWrapper = withModalProvider<DeleteButtonProps>(DeleteButton);